/**
 * @generated SignedSource<<929869f46dc30aa456860d5a899e6977>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TradeBenefitsHeroStatusContact_tradeFirm$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useTradeBenefitsContact_tradeFirm">;
  readonly " $fragmentType": "TradeBenefitsHeroStatusContact_tradeFirm";
};
export type TradeBenefitsHeroStatusContact_tradeFirm$key = {
  readonly " $data"?: TradeBenefitsHeroStatusContact_tradeFirm$data;
  readonly " $fragmentSpreads": FragmentRefs<"TradeBenefitsHeroStatusContact_tradeFirm">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TradeBenefitsHeroStatusContact_tradeFirm",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useTradeBenefitsContact_tradeFirm"
    }
  ],
  "type": "TradeFirmType",
  "abstractKey": null
};

(node as any).hash = "b4be18ae02e9233bb9f0b3f4fc09b7ec";

export default node;
